import { KitButton, KitLoader, KitText } from '@omni/kit/components';
import { useTranslation } from '@omni/kit/hooks/useTranslation';
import Spacing from '@omni/kit/theming/Spacing';
import React, { ReactElement, useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';

interface IProps {
  onRetryButtonPress: () => void;
  isMessagingEnabled: boolean;
}

export default function ErrorView({
  onRetryButtonPress,
  isMessagingEnabled,
}: IProps): ReactElement {
  const { t } = useTranslation(['common']);
  const [showContent, setShowContent] = useState(false);
  const showContentTimeoutInMillis = 2000;

  useEffect(() => {
    setTimeout(() => {
      setShowContent(true);
    }, showContentTimeoutInMillis);
  }, []);

  return (
    <View style={styles.errorView}>
      {!showContent ? <KitLoader /> : null}
      {showContent ? (
        <View>
          {!isMessagingEnabled ? (
            <KitText black fontSize={28} bold center style={styles.headerText}>
              {t('messaging:conversationsAreNoLongerAvailable')}
            </KitText>
          ) : (
            <>
              <KitText
                black
                fontSize={28}
                bold
                center
                style={styles.headerText}
              >
                {t('common:somethingWentWrong')}
              </KitText>
              <KitText gray fontSize={16} center style={styles.paragraphText}>
                {t(
                  'common:weHadAProblemLoadingSomeOfYourContentPleaseTryAgain'
                )}
              </KitText>
              <KitButton title='Retry' onPress={onRetryButtonPress} />
            </>
          )}
        </View>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  errorView: {
    left: Spacing.l,
    position: 'absolute',
    right: Spacing.l,
    alignItems: 'center',
  },
  headerText: {
    marginTop: Spacing.l,
  },
  loadingStyle: {
    alignItems: 'center',
    bottom: 80,
    justifyContent: 'center',
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
  },
  paragraphText: {
    marginBottom: Spacing.m,
    marginTop: Spacing.m,
  },
});
